var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragAndDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_904_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98029 8.55042C2.44537 8.55042 2.82239 8.1734 2.82239 7.70832C2.82239 7.24323 2.44537 6.86621 1.98029 6.86621C1.51521 6.86621 1.13818 7.24323 1.13818 7.70832C1.13818 8.1734 1.51521 8.55042 1.98029 8.55042Z",
    stroke: "#BCC4D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98029 2.65565C2.44537 2.65565 2.82239 2.27862 2.82239 1.81354C2.82239 1.34846 2.44537 0.971436 1.98029 0.971436C1.51521 0.971436 1.13818 1.34846 1.13818 1.81354C1.13818 2.27862 1.51521 2.65565 1.98029 2.65565Z",
    stroke: "#BCC4D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98029 14.4451C2.44537 14.4451 2.82239 14.0681 2.82239 13.603C2.82239 13.1379 2.44537 12.7609 1.98029 12.7609C1.51521 12.7609 1.13818 13.1379 1.13818 13.603C1.13818 14.0681 1.51521 14.4451 1.98029 14.4451Z",
    stroke: "#BCC4D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_904_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87482 8.55042C8.3399 8.55042 8.71693 8.1734 8.71693 7.70832C8.71693 7.24323 8.3399 6.86621 7.87482 6.86621C7.40974 6.86621 7.03271 7.24323 7.03271 7.70832C7.03271 8.1734 7.40974 8.55042 7.87482 8.55042Z",
    stroke: "#BCC4D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87482 2.65565C8.3399 2.65565 8.71693 2.27862 8.71693 1.81354C8.71693 1.34846 8.3399 0.971436 7.87482 0.971436C7.40974 0.971436 7.03271 1.34846 7.03271 1.81354C7.03271 2.27862 7.40974 2.65565 7.87482 2.65565Z",
    stroke: "#BCC4D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87482 14.4451C8.3399 14.4451 8.71693 14.0681 8.71693 13.603C8.71693 13.1379 8.3399 12.7609 7.87482 12.7609C7.40974 12.7609 7.03271 13.1379 7.03271 13.603C7.03271 14.0681 7.40974 14.4451 7.87482 14.4451Z",
    stroke: "#BCC4D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_904_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.21053,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_904_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.21053,
    height: 16,
    fill: "white",
    transform: "translate(5.89453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/drag-and-drop.b0efab10d27e3f4ff7d1c0fa8e32eefb.svg";
export { ForwardRef as ReactComponent };